/**
 * Mixin metod
 * Zawiera metody:
 *  - `deepClone(src)` - Klonuje obiekt
 */
export const methodsMixin = {
  methods: {
    /**
     * Klonuje obiekt
     *
     * @param {*} src
     */
    deepClone(src) {
      return JSON.parse(JSON.stringify(src));
    },

    /**
     * Ustawia fokusa na pierwszym inpucie ostatniego elementu
     *
     * @param {*} refName
     */
    setFocusOnLastChildInput(refName) {
      this.$nextTick(() => {
        if (this.$refs[refName].lastChild.hasChildNodes()) {
          this.$refs[refName].lastChild.querySelector('input').focus();
        }
      });
    },

    /**
     * Ustawia fokusa na pierwszym inpucie elementu
     *
     * @param {*} refName
     */
    setFocusOnInput(refName) {
      this.$nextTick(() => {
        if (this.$refs[refName].$el.hasChildNodes()) {
          this.$refs[refName].$el.querySelector('input').focus();
        }
      });
    }
  }
};
